module.exports = __webpack_public_path__ + "img/checkIcon.dcbc88a6.svg";